import { showGeneralModal } from "@/App/components/Dispatch/showGeneralModal";
import { confirmationModalId } from "@/Pages/Cases/store";

export const showEndLiveConsultModal = (onConfirm: () => void) => {
  showGeneralModal(
    confirmationModalId,
    "End Current Live Consult?",
    "Navigating away from this Case will end the current Live Consult. Do you wish to continue?",
    onConfirm,
  );
};
